import AppSimpleBar from "components/AppSimpleBar";
import UserAvatar from "components/UserAvatar";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import classnames from "classnames";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { useEffect } from "react";
import { changeSelectedContentTitleKeyId, changeSelectedContentTitle, reduceContentTitleUnread, setActiveWebUserId } from "../../../redux/actions";
import classNames from "classnames";
import { CONTENT_TITLE_NAME } from "../../../constants";
import { ThirdApi } from "api/apiThird";
import { getWebUserId } from "api";
import { APIClient } from "api/apiCore";
import { Const } from "const";
import { sp_GetWebUserId } from "types";
import MyMap from "components/MyMap";
import ContentDeliveryMap from "./ContentDeliveryMap";
import Content2SOnlinePendingDO from "./Content2SOnlinePendingDO";
import LoadingIconWithText from "components/LoadingIconWithText";



const ContentList = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Chats,
    (state: any) => state.Profile2,
    (state, p2) => ({
      selectedContentTitle: state.selectedContentTitle,
      selectedContentTitleMode: state.selectedContentTitleMode,
      selectedContentTitleLoading: state.selectedContentTitleLoading,
      contentTitles: state.contentTitles ?? [],
      contentTitleInfo: state.contentTitleInfo ?? {},
      custContents: state.custContents,
      selectedContentTitleKey: state.selectedContentTitleKey,
      activeGroupId: p2.activeGroupId,
    })
  );
  // Inside your component
  const {
    selectedContentTitle, selectedContentTitleMode, selectedContentTitleLoading, contentTitles, contentTitleInfo
    , custContents, activeGroupId, selectedContentTitleKey
  } = useAppSelector(storeData);

  const getContentTitle = () => {
    for (let i = 0; i < custContents.length; ++i) {
      for (let j = 0; j < custContents[i].contentTitles.length; ++j) {
        if (custContents[i].contentTitles[j].contentTitleId === selectedContentTitle) {
          return custContents[i].contentTitles[j];
        }
      }
    }
    return null;
  };

  const contentTitleSel = getContentTitle();
  const isDark = Utils.IsDarkTheme();

  const ContentHead = (showReloadIcon: boolean) => {
    const onHeaderClick = () => {
      dispatch(changeSelectedContentTitle(activeGroupId, null, 'onHeaderClick', null));
    }
    const onClickReload = () => {
      dispatch(changeSelectedContentTitle(activeGroupId, selectedContentTitle, 'onClickReload', selectedContentTitleMode));
    }
    const isOnline = false;
    const contentTitle = contentTitleSel?.titleName;

    return (
      <div className="d-flex align-items-center " style={{ borderBottom: "dashed gray 1px" }}>
        <div className="flex-shrink-0 d-block d-md-none me-2">
          <Link
            to="#"
            onClick={onHeaderClick}
            className={classnames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
          >
            <i className="bx bx-chevron-left align-middle"></i>
          </Link>
        </div>
        <div className="flex-grow-1 overflow-hidden ">
          <div className="d-flex align-items-center">
            <div
              className={classnames(
                "flex-shrink-0",
                "chat-user-img",
                "align-self-center",
                "me-3",
                "ms-0",
                { online: isOnline }
              )}
            >
              <>
                {/* <img
                                    src={profileImage}
                                    className="rounded-circle avatar-sm"
                                    alt=""
                                /> */}
                <i className={contentTitleSel?.titlePictureUrl} style={{ fontSize: '32pt' }}></i>
                {/* <span
                                    className={classnames("user-status", "bg-success")}
                                ></span> */}
              </>
            </div>
            <div className="flex-grow-1 overflow-hidden">
              <h6 className="text-truncate mb-0 font-size-18">
                <Link to="#" className="user-profile-show text-reset" onClick={(e) => e.preventDefault()}>
                  {contentTitle}
                </Link>
                {showReloadIcon && (
                  <>
                    &nbsp;
                    {selectedContentTitleLoading && (<LoadingIconWithText loadingText={""} />)}
                    {!selectedContentTitleLoading && (<i className="fas fa-redo hand" onClick={onClickReload}></i>)}
                  </>
                )}

              </h6>
            </div>
          </div>
        </div>
      </div>
    );
  }

  interface GenIconProps {
    url: string;
    allowClick: boolean;
    title: any;
  }
  const GenIcon: React.FC<GenIconProps> = ({ url, allowClick, title }) => {
    return (
      url.includes('/')
        ? <img className={classnames("content-list-icon", { "hand": allowClick })} src={url} onClick={allowClick ? (event) => { event.preventDefault(); onEachTitleClick(event, title) } : undefined} />
        : <i className={classnames("content-list-icon " + url, { "hand": allowClick })} onClick={allowClick ? (event) => { event.preventDefault(); onEachTitleClick(event, title) } : undefined}></i>
    )
  }

  const EachTitle = (title2: any) => {
    const title = title2.title;
    const cssUnRead = ((title?.isRead) ?? true) ? "" : (Utils.GetCssSuffixTheme("content-title-unread"));
    return (
      <li
        className={classnames("mb-2 p-1 " + cssUnRead, { "hand": title.fullRowClick === undefined })}
        onClick={(title.fullRowClick === undefined) ? (event) => { event.preventDefault(); onEachTitleClick(event, title); return false; } : undefined}
      >
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0 ms-1 me-2">
            {title.thumb && (
              <img className="content-list-icon" src={title.thumb} />
            )}
            {!title.thumb && title.icon && (
              <img className="content-list-icon" src={title.icon} />
            )}
          </div>

          <div className="flex-grow-1 overflow-hidden">
            <h5 className="fz-10 mb-1 no-wrap">
              {title.title}
              {title.statusBadge && (<span className={`ms-2 bs-badge bs-badge-${title.statusBadge}`}>{title.status}</span>)}

            </h5>
            <p className="text-muted text-truncate fz-09 mb-0">{(title.title2 == "" ? " " : title.title2)}</p>
          </div>

          {(title.titleR1 || title.titleR2) && (
            <div className="flex-shrink-0 ms-1 text-end">
              <div className="text-info">{title.titleR1}</div>
              <div className="text-muted text-truncate text-secondary font-size-13 mb-0">{title.titleR2}</div>
            </div>
          )}

          {(title.iconR || title.iconR2) && (
            <div className="d-flex flex-shrink-0 ms-2" style={{ gap: "5px" }}>
              {title.iconR && (<GenIcon url={title.iconR} allowClick={title.clickIconR} title={title} />)}
              {title.iconR2 && (<GenIcon url={title.iconR2} allowClick={title.clickIconR2} title={title} />)}
            </div>
          )}
        </div>
      </li>
    );
  }

  const onEachTitleClick = async (event: any, title: any) => {
    // console.log('click title:', contentTitleSel, title);
    // return;
    // const webUserId = await getWebUserId(activeGroupId);
    // dispatch(setActiveWebUserId(webUserId));
    const resp = await getWebUserId(activeGroupId);
    // console.log('setActiveWebUserId at  onEachTitleClick:resp=', resp);
    dispatch(setActiveWebUserId(resp.webUserId, resp.customerIsCdSys));


    if (contentTitleSel.canOpen == false) {
      alert(Const.NO_PERMISSION_ON_DCONNECT);
    } else {
      //const rs = new ThirdApi().DConnect_RegisterWebUserId(webUserId); // register cookie
      const rs = new ThirdApi().DConnect_RegisterWebUserId(resp.customerIsCdSys, resp.webUserId); // register cookie
      if (resp.webUserId > 0 && contentTitleSel?.updateUnreadOnOpen) { // reduce unread count
        dispatch(reduceContentTitleUnread(contentTitleSel.contentTitleId, title.keyId));
      }

      if (title.contentMode == 'OpenList') { // open other link
        // remember last 
        const now = new Date();
        const expireMillSec = 1000 * 60 * 30; // 30 minute
        const lastActiveTitle = {
          activeGroupId,
          selectedContentTitle,
          selectedContentTitleMode: title.contentMode,
          expire: now.getTime() + expireMillSec
        };
        localStorage.setItem("lastActiveTitle", JSON.stringify(lastActiveTitle));

        //console.log('OpenLink: ' + title.keyUrl);
        const orgLink = title.keyUrl;
        const newLink = await Utils.GetExternalUrl('Each Title Click', orgLink, resp.webUserId, resp.customerIsCdSys);
        if (event.ctrlKey) {
          window.open(newLink /*title.keyUrl*/, '_blank'); // Open in new tab if Ctrl is held
        } else {
          if (Utils.IsDesktop()) {
            const url2 = newLink.replace('https://docs.google.com/gview?embedded=true&url=', '');
            Utils.OpenUrlInSameTab(url2, title.contentTitle);
          } else {
            window.location.href = newLink/* title.keyUrl*/;
          }
        }
      } else { // display content inside chat
        try {
          if (title.contentTitle == CONTENT_TITLE_NAME.NEWS) { // all other api for update unread
            if (resp.webUserId > 0 && resp.customerIsCdSys == 1 /*dconnect*/) {
              new ThirdApi().DConnect_UpdateNewsUnread(resp.customerIsCdSys, title.keyId);
            }
          }
        } catch (e) {
          console.error(e);
        }
        //console.log('changeSelectedContentTitleKeyId:', { activeGroupId, selectedContentTitle, keyId: title.keyId });
        // console.log('target:', event.target);
        // console.log('title:', title);
        // console.log([event.target.src, "/icons/map_yes.png"]);

        let route = false;
        if (title.contentTitle == CONTENT_TITLE_NAME.DELIVERY_STATUS) {
          if (event.target.src.endsWith("/icons/map_yes.png")) {
            route = true;
          } else if (event.target.src.endsWith("/icons/tel_ok.png") && title.phoneNo) {
            if (Utils.IsDesktop()) {
              alert(title.phoneNo);
            } else {
              window.location.href = `tel:${title.phoneNo}`;
            }
          }
        } else {
          route = true;
        }

        if (route) {
          dispatch(changeSelectedContentTitleKeyId(activeGroupId, selectedContentTitle, title.keyId));
        }



        //  
      }
    }
  }

  const onCloseContentPreview = () => { dispatch(changeSelectedContentTitleKeyId(activeGroupId, selectedContentTitle, null)) }

  interface ContentHtml_DefaultProps {
    contentDetails: any;
  }

  const ContentHtml_Default: React.FC<ContentHtml_DefaultProps> = ({ contentDetails }) => {
    return (
      <>
        <div className="d-flex align-items-start">
          <div className="flex-grow-1 align-self-center">
            <h4 className={"content-html-header" + (isDark ? "-dark" : "")}>{contentDetails.title}
            </h4>
          </div>
          <div className="flex-shrink-0">
            <div id="close-title">
              {/* <button type="button" className="btn btn-soft-primary " onClick={onCloseContentPreview} > */}
              <i className={"bx bx-x-circle hand content-html-header-close" + (isDark ? "-dark" : "")} onClick={onCloseContentPreview} ></i>
              {/* </button> */}
            </div>
          </div>
        </div>
        <br />
        <div className="">
          <div dangerouslySetInnerHTML={{ __html: contentDetails.contentHtml }}></div>
          {contentDetails.thumb && (
            <img src={contentDetails.thumb} style={{ width: "100%", maxWidth: "1000px" }} />
          )}
        </div>
      </>
    )
  }


  const ContentHtml = () => {
    const details = contentTitles.find((item: any) => item.keyId === selectedContentTitleKey);
    const mode_map = details.contentTitle === CONTENT_TITLE_NAME.DELIVERY_STATUS;
    const title1 = mode_map ? (/*details.title + ' ' +*/ details.titleR1) : details.title;
    const title2 = mode_map ? ('ส่งที่:' + details.title2) : null;
    // console.log('reder html = ', details);
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <div className="flex-grow-1 align-self-center">
            <h4 className={"content-html-header" + (isDark ? "-dark" : "")}>{title1}</h4>
            {title2 && (<p>{title2}</p>)}
          </div>
          <div className="flex-shrink-0">
            <div id="close-title">
              {/* <button type="button" className="btn btn-soft-primary " onClick={onCloseContentPreview} > */}
              <i style={{ fontSize: "2em" }} className={"bx bx-x-circle hand content-html-header-close" + (isDark ? "-dark" : "")} onClick={onCloseContentPreview} ></i>
              {/* </button> */}
            </div>
          </div>
        </div>
        {/* <br /> */}
        <div >
          {mode_map
            ? (<ContentDeliveryMap contentTitleDetails={details} />)
            : (
              <>
                <div dangerouslySetInnerHTML={{ __html: details.contentHtml }} className="bg-white p-2" style={{ borderRadius: "10px" }}></div>
                {details.thumb && (
                  <img src={details.thumb} style={{ width: "100%", maxWidth: "1000px" }} />
                )}
              </>
            )
          }
        </div>
      </>
    )
  }

  const showReloadIconAtHead =
    (contentTitleInfo.customerIsCdSys == Const.APP_2SONLINE && contentTitleInfo.titleName == CONTENT_TITLE_NAME.NON_RECEIVING_PRODUCT);
  // console.log('showReloadIconAtHead = ' + showReloadIconAtHead);


  return (
    <>
      <AppSimpleBar className="p-3 p-md-4 positin-relative content-list-head " >
        {ContentHead(showReloadIconAtHead)}
        {/* <ContentHead  /> */}
      </AppSimpleBar>



      {contentTitleInfo.customerIsCdSys == Const.APP_2SONLINE && contentTitleInfo.titleName == CONTENT_TITLE_NAME.NON_RECEIVING_PRODUCT
        ? (<Content2SOnlinePendingDO />)
        : (
          <AppSimpleBar className="p-3 p-md-4 positin-relative content-list-ul ">
            {selectedContentTitleLoading && (<Loader />)}

            {selectedContentTitleKey && (
              <ContentHtml />
            )}

            {!selectedContentTitleKey && (
              <ul className="list-unstyled" id="chat-conversation-list" >
                {contentTitles.map((title: any, key: number) => {
                  return <EachTitle key={key} title={title} />
                })}
              </ul>
            )}
          </AppSimpleBar>
        )
      }


    </>
  );
}

export default ContentList;